import {gql} from "@apollo/client";
import {
    CreateParams,
    DeleteManyParams,
    DeleteParams,
    GetListParams,
    GetManyParams,
    GetManyReferenceParams,
    GetOneParams,
    UpdateManyParams,
    UpdateParams,
} from "react-admin";
import {UpdateNotificationInput} from "../../../graphql/graphql";
import {ResourceDataProvider} from "../../dataProvider/ResourceDataProvider";

export class NotificationsDataProvider extends ResourceDataProvider {
    public resource = "notifications";

    // TODO: implement
    async create(params: CreateParams) {
        throw new Error("Not implemented");
        return {data: {} as any};
    }

    // TODO: implement
    async delete(params: DeleteParams) {
        throw new Error("Not implemented");
        return {data: {} as any};
    }

    // TODO: implement
    async deleteMany(params: DeleteManyParams) {
        throw new Error("Not implemented");
        return {};
    }

    async getList(params: GetListParams) {
        const query = gql`
            {
                notifications(
                    page: ${params.pagination.page},
                    perPage: ${params.pagination.perPage},
                    sortField: "${params.sort.field}",
                    sortOrder: "${params.sort.order}"
                ) {
                    nodes {
                        id
                        message
                        data
                        level
                        entityName
                        entityId
                        dismissed
                        count
                        createdAt
                        updatedAt
                    }
                    length
                }
            }
        `;

        const result = await this.client.query({query});

        return {
            data: result.data.notifications.nodes,
            total: result.data.notifications.length,
        };
    }

    async getMany(params: GetManyParams) {
        const query = gql`
            {
                notifications {
                    id
                    message
                    level
                    entityName
                    entityId
                    dismissed
                }
            }
        `;

        const result = await this.client.query({query});

        return {
            data: result.data.notifications,
            total: result.data.notifications.length,
        };
    }

    // TODO: implement
    async getManyReference(params: GetManyReferenceParams) {
        throw new Error("Not implemented");
        return {data: [], total: 0};
    }

    async getOne(params: GetOneParams) {
        const query = gql`
            {
                notification(id: ${params.id}) {
                    id
                    message
                    level
                    entityName
                    entityId
                    dismissed
                }
            }
        `;

        const result = await this.client.query({query});

        return {
            data: result.data.notification,
        };
    }

    async update(params: UpdateParams) {
        const query = gql`
            mutation UpdateNotificationInput($input: UpdateNotificationInput!) {
                updateNotification(input: $input) {
                    id
                }
            }
        `;

        const data = params.data;
        const input: UpdateNotificationInput = {
            id: data.id,
            message: data.message,
            level: data.level,
            entityName: data.entityName,
            entityId: data.entityId,
            dismissed: data.dismissed,
        };
        const result = await this.client.query({query, variables: {input}});

        return {
            data: result.data.updateNotification,
        };
    }

    // TODO: implement
    async updateMany(params: UpdateManyParams) {
        throw new Error("Not implemented");
        return {data: []};
    }
}
